import React from 'react';

/**
 * Headphones (Untitled UI `headphones-01`). Sourced verbatim from Figma —
 * used in the Admin 3.0 «Navbar» Support button (797:54118), where Heroicons
 * (the bell beside it) has no match, and ready to be reused anywhere a
 * "support" icon is needed. The path is moved from the 40px nav-button export
 * into the icon's own 24px frame.
 *
 * Sized at `1em` so it scales with the parent's `font-size`. Strokes with
 * `currentColor` (1.5, like the Heroicons outline set) so consumers control
 * the color via CSS.
 */
function HeadphonesIcon(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="1em"
            height="1em"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            {...props}
        >
            <path d="M21 18V12C21 7.0294 16.9706 3 12 3C7.0294 3 3 7.0294 3 12V18M5.5 21C4.1193 21 3 19.8807 3 18.5V16.5C3 15.1193 4.1193 14 5.5 14C6.8807 14 8 15.1193 8 16.5V18.5C8 19.8807 6.8807 21 5.5 21ZM18.5 21C17.1193 21 16 19.8807 16 18.5V16.5C16 15.1193 17.1193 14 18.5 14C19.8807 14 21 15.1193 21 16.5V18.5C21 19.8807 19.8807 21 18.5 21Z" />
        </svg>
    );
}

export default HeadphonesIcon;
